// globalState.js
import { reactive } from 'vue';

export const globalState = reactive({
  showEchartsData: false, // 定义一个全局变量 A
});